import React from 'react'

import Typography from '@mui/material/Typography'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import Link from '@mui/material/Link'
import { Button, Grid } from '@mui/material'
// import filterIcon from './../../assets/icons/filter 1.png'
// import searchIcon from './../../assets/icons/searchIcon 1.png'

import filterIcon from './../../../assets/icons/filter 1.png'
import searchIcon from './../../../assets/icons/searchIcon 1.png'
import AddItemDialogComponent from './AddItemDialog.tsx'

import { useSelector, useDispatch } from 'react-redux'

import { testTrue, testFalse } from './../../../reduxadmin/Actions/index'
import AddRestaurantDialog from '../../restaurantsetup/components/AddRestaurantDialog/AddRestaurantDialog.tsx'
import VATSetupDialog from '../../restaurantsetup/components/VATSetupDialog/VATSetupDialog.tsx'
import AddEmployeeDialog from '../../restaurantsetup/components/AddEmployeeDialog/AddEmployeeDialog.tsx'
import AddDiscountDialog from './AddDiscountItems/components/AddDiscountDialog/AddDiscountDialog.tsx'
import AddRecommendationDialog from './AddRecommendation/AddRecommendationDialog/AddRecommendationDialog.tsx'
import AddSubscriptionDialog from './AddSubscription/AddSubscriptionDialog/AddSubscriptionDialog.tsx'
import AddCorporateMenuDialog from './AddCorporateMenu/components/AddCorporateMenuDialog.tsx'
import AddWholeSaleMenuDialog from './AddWholeSaleMenu/AddWholeSaleMenuDialog/AddWholeSaleMenuDialog.tsx'
import AddDiscountOfferItemForHomePage from '../../SettingsForAdmin/AddDiscountOfferToHomePage/AddDiscountOfferItemForHomePage/AddDiscountOfferItemForHomePage.tsx'
import AddSubscriptinOfferItemToHomePage from '../../SettingsForAdmin/AddSubscriptinOfferToHomePage/AddSubscriptinOfferItemToHomePage/AddSubscriptinOfferItemToHomePage.tsx'
import AddWholeSellSetupDialog from '../../SettingsForAdmin/AddWholesellSetup/AddWholeSellSetupDialog/AddWholeSellSetupDialog.tsx'
import AddRecommendedItemForHomePageDialog from '../../SettingsForAdmin/AddRecommendedItemForHomePage/AddRecommendedItemForHomePageDialog/AddRecommendedItemForHomePageDialog.tsx'
import AddFoodHistoryDialog from './AddFoodHistory/AddFoodHistoryDialog/AddFoodHistoryDialog.tsx'
import AddTagsForHomePage from '../../SettingsForAdmin/AddTagsForHomePage/AddTagsForHomePage.tsx'
import AddTagsToHomePage from '../../SettingsForAdmin/AddTagsForHomePage/AddTagsToHomePage/AddTagsToHomePage.tsx'
import ScheduleItemDialog from './SchedulerView/ScheduleItemDialog/ScheduleItemDialog.tsx'
import AddSpecification from './AddSpecifications/AddSpecification.tsx'
import InventoryDialog from './InventoryView/InventoryDialog/InventoryDialog.tsx'

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import ListItemText from '@mui/material/ListItemText';

import plus from './../../../assets/icons/plusDropDown.png'
import AddKitchenDialog from '../../restaurantsetup/components/AddKitchenDialog/AddKitchenDialog.tsx'

function FilterComponents(props) {
  const [open, setOpen] = React.useState(false)
  const dispatch = useDispatch()

  //dialog start
  const handleClickOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (props.isItem != 6) {
      setOpen(true)
    }
    else {
      setAnchorEl(event.currentTarget);
    }
  }
  const openSetupModal = () => {
    setOpen(true)
  }
  const handleAddItem = (AddItemData) => {
    setOpen(AddItemData)
  }

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const openDropdown = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          mt={2}
          mb={2}
        >
          <Grid item>
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <Button
                  color="primary"
                  size="medium"
                  variant="contained"
                  style={{ borderRadius: '50%', minWidth: 'auto' }}
                  onClick={handleClickOpen}
                >
                  +
                </Button>
              </Grid>
              {/* <Grid item>
                <img src={filterIcon} alt="" style={{ width: '1rem' }} />
              </Grid>
              <Grid item>Add Filter</Grid> */}
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={openDropdown}
                onClose={handleClose}
                MenuListProps={{
                  'aria-labelledby': 'basic-button',
                }}
              >
                <MenuList >
                  <MenuItem>
                    <ListItemText>
                      <div className='d-flex align-items-center' style={{ gap: "10px", height: "2.5rem" }}>
                        <div>
                          <img src={plus} alt="" style={{ width: "1.2rem" }} />
                        </div>
                        <span style={{ fontSize: "1rem", color: "gray" }}>
                          Add Item to Subcription List
                        </span>
                      </div>
                    </ListItemText>
                  </MenuItem>
                  <MenuItem>
                    <ListItemText>
                      <div className='d-flex align-items-center' style={{ gap: "10px", height: "2.5rem" }}>
                        <div>
                          <img src={plus} alt="" style={{ width: "1.2rem" }} />
                        </div>
                        <span style={{ fontSize: "1rem", color: "gray" }}>
                          Add Add-ons to Subscription list
                        </span>
                      </div>
                    </ListItemText>
                  </MenuItem>
                  <MenuItem>
                    <ListItemText>
                      <div className='d-flex align-items-center' style={{ gap: "10px", height: "2.5rem" }} onClick={() => {
                        openSetupModal()
                      }}>
                        <div>
                          <img src={plus} alt="" style={{ width: "1.2rem" }} />
                        </div>
                        <span style={{ fontSize: "1rem", color: "gray" }}>
                          Create your own subscription plan
                        </span>
                      </div>
                    </ListItemText>
                  </MenuItem>
                </MenuList>
                {/* <MenuItem onClick={handleClose}></MenuItem>
                <MenuItem onClick={handleClose}></MenuItem>
                <MenuItem onClick={handleClose}>Add Add-ons to Subscription list</MenuItem> */}
              </Menu>
            </Grid>
          </Grid>
          <Grid item>
            <Grid container flexDirection={'column'} alignItems={'center'}>
              {/* <Grid item>
                <img src={searchIcon} alt="" style={{ width: '1rem' }} />
              </Grid>
              <Grid item>Search</Grid> */}
            </Grid>
          </Grid>
        </Grid>
      </div >
      <hr></hr>
      {

        props.isItem == 0 ? <AddItemDialogComponent
          open={open}
          onHandleAddItem={handleAddItem}
          title={props.title}
        /> : props.isItem == 1 ? <AddRestaurantDialog open={open}
          onHandleAddItem={handleAddItem}
          title={props.title} /> : props.isItem == 2 ? <VATSetupDialog open={open}
          /> : props.isItem == 18 ? <AddKitchenDialog open={open}
            onHandleAddItem={handleAddItem}
            title={props.title} /> : props.isItem == 2 ? <VATSetupDialog open={open}
              onHandleAddItem={handleAddItem}
              title={props.title} /> : props.isItem == 3 ? <AddEmployeeDialog open={open}
                onHandleAddItem={handleAddItem}
                title={props.title} /> : props.isItem == 4 ? <AddDiscountDialog open={open}
                  onHandleAddItem={handleAddItem}
                  title={props.title} /> : props.isItem == 5 ? <AddRecommendationDialog open={open}
                    onHandleAddItem={handleAddItem}
                    title={props.title} /> : props.isItem == 6 ? <AddSubscriptionDialog open={open}
                      onHandleAddItem={handleAddItem}
                      title={props.title} /> : props.isItem == 7 ? <AddCorporateMenuDialog open={open}
                        onHandleAddItem={handleAddItem}
                        title={props.title} /> : props.isItem == 8 ? <AddWholeSaleMenuDialog open={open}
                          onHandleAddItem={handleAddItem}
                          title={props.title} /> : props.isItem == 9 ? <AddDiscountOfferItemForHomePage open={open}
                            onHandleAddItem={handleAddItem}
                            title={props.title} /> : props.isItem == 10 ? <AddSubscriptinOfferItemToHomePage open={open}
                              onHandleAddItem={handleAddItem}
                              title={props.title} /> : props.isItem == 11 ? <AddWholeSellSetupDialog open={open}
                                onHandleAddItem={handleAddItem}
                                title={props.title} /> : props.isItem == 12 ? <AddRecommendedItemForHomePageDialog open={open}
                                  onHandleAddItem={handleAddItem}
                                  title={props.title} /> : props.isItem == 13 ? <AddFoodHistoryDialog open={open}
                                    onHandleAddItem={handleAddItem}
                                    title={props.title} /> : props.isItem == 14 ? <AddTagsToHomePage open={open}
                                      onHandleAddItem={handleAddItem}
                                      title={props.title} /> : props.isItem == 15 ? <ScheduleItemDialog open={open}
                                        onHandleAddItem={handleAddItem}
                                        title={props.title} /> : props.isItem == 16 ? <AddSpecification open={open}
                                          onClose={handleAddItem}
                                          onSave={handleAddItem} dialogName={"Add On"} /> : props.isItem == 17 ? <InventoryDialog open={open}
                                            onClose={handleAddItem}
                                            onSave={handleAddItem} dialogName={"Add On"} /> : <p>Coming soon</p>
      }

    </>
  )
}

export default FilterComponents
